import React from 'react';
import { Box, Typography } from '@mui/material';
import LandingLayout from './LandingLayout';
import { LEGAL_LAST_UPDATED } from '../data/legalContent';

const PRESSTO_NAVY = '#163567';
const PRESSTO_PURPLE = '#5C4FB8';
const TEXT_DARK = '#1e1e1e';
const TEXT_BODY = '#374151';

const SERIF = '"Georgia", "Times New Roman", serif';
const SANS = 'Lato, Inter, "Helvetica Neue", Arial, sans-serif';
const DISPLAY = 'Montserrat, sans-serif';

interface LegalPageProps {
  /** Page heading, e.g. "Privacy Policy" */
  title: string;
  /** Cleaned legal copy (<strong> sub-heads + <br/> line breaks) */
  html: string;
}

/** Plain, readable scaffold for Pressto's legal pages. */
export default function LegalPage({ title, html }: LegalPageProps) {
  return (
    <LandingLayout>
      <Box sx={{ backgroundColor: '#FFFFFF', px: { xs: 3, md: 6 }, py: { xs: 5, md: 7 } }}>
        <Box sx={{ maxWidth: 760, mx: 'auto' }}>
          <Typography
            component="h1"
            sx={{
              fontFamily: SERIF,
              fontWeight: 700,
              fontSize: { xs: '2rem', md: '2.5rem' },
              color: TEXT_DARK,
              letterSpacing: '-0.01em',
              mb: LEGAL_LAST_UPDATED ? 0.75 : 4,
            }}
          >
            {title}
          </Typography>
          {LEGAL_LAST_UPDATED && (
            <Typography sx={{ fontFamily: SANS, fontSize: '0.85rem', color: '#9CA3AF', mb: 4 }}>
              Last updated: {LEGAL_LAST_UPDATED}
            </Typography>
          )}
          <Box
            sx={{
              fontFamily: SANS,
              fontSize: '1rem',
              lineHeight: 1.85,
              color: TEXT_BODY,
              '& strong': {
                display: 'block',
                fontFamily: DISPLAY,
                fontWeight: 800,
                fontSize: '1.15rem',
                color: PRESSTO_NAVY,
                mt: 4,
                mb: 1.25,
              },
              '& a': { color: PRESSTO_PURPLE, fontWeight: 600 },
              '& strong:first-of-type': { mt: 0 },
            }}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </Box>
      </Box>
    </LandingLayout>
  );
}
